import React, { useEffect, useState } from "react";
import { LeaveRequest } from "@/models/leave-requests.model";
import IndivLeaveRequestDataTable from "./indiv-staff-table/IndivLeaveRequestDataTable";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { fetchLeaveRequests, fetchLeaveRequestsOfUser } from "@/features/leaveRequests/leaveRequestSlice";
import { Button } from "../ui/button";
import { selectUserLeaveRequests } from "@/features/leaveRequests/leaveRequestSelector";
import { CalendarPlus, ChevronLeft, ChevronRight } from "lucide-react";
import RequestOnBehalf from "./RequestOnBehalf";
import { User } from "@/models/user.model";


interface Props {
  user: User;
}
function AdminLeaveRequestCard({ user }: Props) {
  const dispatch = useAppDispatch();
  const { requests, pagination } = useAppSelector(selectUserLeaveRequests);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchLeaveRequestsOfUser({ userId: user.id, page: currentPage }));
  }, [dispatch, currentPage, user.id]);

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    if (pagination.totalPages > 0) {
      setCurrentPage(1);
    } else {
      setCurrentPage(0); // no pages available
    }
  }, [pagination.totalPages]);


  return (
    <div className="rounded-md w-full h-[400px] p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
      <div className="flex flex-row justify-between items-center">
        <div className="font-bold text-lg">Leave Request</div>

        <div className="flex flex-row gap-2 items-center">

          <Button onClick={() => setIsCreateOpen(true)} size={"sm"}
          >
            <CalendarPlus />
          </Button>
          <div className="flex justify-between items-center gap-2">
            <Button
              onClick={handlePrev}
              variant={"outline"}
              size={"sm"}
              disabled={currentPage <= 1}
            >
              <ChevronLeft />
            </Button>
            <span className="text-sm text-gray-600">
              Page {currentPage} of {pagination.totalPages}
            </span>
            <Button
              onClick={handleNext}
              disabled={currentPage >= Math.ceil((pagination?.totalElements || 0) / 7)}
              variant={"outline"}
              size={"sm"}
            >
              <ChevronRight />
            </Button>
          </div>
        </div>

      </div>


      <div className="h-full max-h-full overflow-y-auto">
        <IndivLeaveRequestDataTable leaveRequests={requests} />

      </div>
      <RequestOnBehalf
        isOpen={isCreateOpen}
        setIsOpen={setIsCreateOpen}
        user={user}
      />

    </div>
  );
}

export default AdminLeaveRequestCard;
